import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Popup, PopupContent } from '@flatfy/supernova-new';
import { isChromeIos } from '../../helpers/browserCheck';
import FlatsFiltersActions from '../FlatsFiltersActions/FlatsFiltersActions';
import useMediaQuery from '../useMediaQuery';

const FlatsFiltersPopup = ({ opened, onClose, children, triggerEl, skipKeys, root }) => {
  const isMediumScreen = useMediaQuery({ maxWidth: 939 });
  const isMobile = useMediaQuery();

  return isMobile ? (
    children
  ) : (
    <Popup
      className="FlatsFiltersPopup"
      opened={opened}
      onClose={onClose}
      anchorEl={triggerEl}
      placement="bottom-start"
      limitHeight
      {...(root && !isMediumScreen && { wrapperEl: root })}
    >
      <PopupContent
        className={cx('FlatsFiltersPopup-content', { '-no-transitions': isChromeIos() })}
        onClose={onClose}
        actions={<FlatsFiltersActions skipKeys={skipKeys} onClose={onClose} />}
      >
        {children}
      </PopupContent>
    </Popup>
  );
};

FlatsFiltersPopup.propTypes = {
  opened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  triggerEl: PropTypes.object,
  skipKeys: PropTypes.array,
  root: PropTypes.object,
};

export default FlatsFiltersPopup;
